import React from 'react'

// This component was created for Foremost Farms, it's a limited date picker for the appointment delivery date

const DELApptDateLimited = ({ render, apptDelDate, shipmentObjUpdateEvent, requestedDeliveryDate, inputFieldsReadOnly }) => {
    if (render && apptDelDate && shipmentObjUpdateEvent) {

        let readOnly = false
        if (!requestedDeliveryDate || inputFieldsReadOnly) {
            readOnly = true
        }

        let minDateStr = ''
        let maxDateStr = ''

        if (!readOnly) {
            const minDate = new Date(requestedDeliveryDate)
            minDate.setDate(minDate.getDate() - 3)
            const maxDate = new Date(requestedDeliveryDate)
            maxDate.setDate(maxDate.getDate() + 3)
            minDateStr = minDate.toISOString().split('T')[0]
            maxDateStr = maxDate.toISOString().split('T')[0]
        }
        return (
            <div className="form-group col col-lg-2">
                <label>Appt. Delivery:</label>
                <input
                    className="form-control form-control-sm"
                    name="dates.appointmentDeliveryDate"
                    onChange={(event) => shipmentObjUpdateEvent(event)}
                    type="date"
                    value={apptDelDate}
                    min={minDateStr}
                    max={maxDateStr}
                    readOnly={readOnly}
                />
            </div>
        )
    } else {
        return null
    }


}

export default DELApptDateLimited
